import styled from 'styled-components';

/**
 * Use transient props to avoid invalid props passed to the DOM.
 * @see https://inscyth-inc.atlassian.net/browse/EE3-352
 */
export const Container = styled.div<{
  $m: [number, number];
  $mt?: number;
  $mr?: number;
  $mb?: number;
  $ml?: number;
}>(({ theme, $m, $mt, $mr, $ml, $mb }) => ({
  borderTopWidth: '0.5rem',
  '&[data-size="large"]': {
    borderTopWidth: '3rem',
  },
  borderTopStyle: 'solid',
  borderTopColor: theme.palette.outerSpace,
  margin: `${$m[0]}rem ${$m[1]}rem`,
  ...($mt !== undefined ? { marginTop: `${$mt}rem` } : null),
  ...($mr !== undefined ? { marginRight: `${$mr}rem` } : null),
  ...($mb !== undefined ? { marginBottom: `${$mb}rem` } : null),
  ...($ml !== undefined ? { marginLeft: `${$ml}rem` } : null),
}));
